import React from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { forceReloadPaths } from "../../../constants";

const NavLinkList = ({
  icon,
  path,
  name,
  state,
  setSideBarOpen,
  sidebarOpen,
}) => {
  const { t } = useTranslation();
  
  return (
    <NavLink
      reloadDocument={forceReloadPaths.includes(path)}
      end
      to={path}
      state={state}
      className={({ isActive, isPending }) =>
        isActive
          ? "nav-link navbar-link-name active px-md-3 px-4 py-2 my-1 rounded-navlinks navlinkMi"
          : "nav-link navbar-link-name px-md-3 px-4 py-2 my-1 rounded-navlinks"
      }
      onClick={() => (setSideBarOpen ? setSideBarOpen(false) : null)}
    >

      <div
        className={`d-flex align-items-center imgTextDiv${
          sidebarOpen ? "" : " justify-content-center"
        }`}
      >
        <div className="d-flex justify-content-center align-items-center">
          <img alt="side-bar" height={18} width={18} src={icon} />
        </div>
        <div
          xs=""
          className="ColumnsNameNav text-nowrap"
          style={{ color: "#2E3033", fontSize: "16px" }}
        >
          {t(name)}
        </div>
      </div>
    </NavLink>
  );
};

export default NavLinkList;
